export const useCardColor = (id: string): string => {
  const colors = [...Array(24).keys()];

  return (colors[
    [...id]
      .map((character) => character.charCodeAt(0))
      .reduce((partialSum, a) => partialSum + a) % colors.length
  ] + 1).toString();
};
